






























import {
  defineComponent,
  useRoute,
  ref,
  useRouter,
  computed,
  onMounted,
} from "@nuxtjs/composition-api";
import OderHeader from "~/modules/checkout/components/shopeepayPayment/OderHeader.vue";
import OderContent from "~/modules/checkout/components/shopeepayPayment/OderContent.vue";
import OderFooter from "~/modules/checkout/components/shopeepayPayment/OderFooter.vue";
import NotificationModal from "~/components/NotificationModal.vue";
import { useUiNotification } from "~/composables";
import { useOderStore } from "~/modules/checkout/stores/oder";
import { useUser } from "~/modules/customer/composables/useUser";

export default defineComponent({
  name: "OderShopeePayment",
  layout: "checkout",
  components: {
    OderContent,
    OderFooter,
    OderHeader,
    NotificationModal,
  },
  setup() {
    const router = useRouter();
    const route = useRoute();
    const oderStore = useOderStore();
    const { isAuthenticated } = useUser();
    const { send: sendNotification } = useUiNotification();

    const paymentUrl = computed(() => {
      return oderStore.paymentUrl;
    });

    const redirectUrl = computed(() => {
      return oderStore.redirectUrl;
    });
    const isCancelPayment = ref(false);

    const cancelCancel = () => {
      isCancelPayment.value = false;
    };

    const confirmCancel = () => {
      isCancelPayment.value = false;
      const currentQuery = { ...route.value.query };
      currentQuery.status = "change";
      router.push({ path: route.value.path, query: currentQuery });
    };

    const productConfiguration = ref(route.value.query);
    const incrementId = productConfiguration.value.increment_id
      ? (productConfiguration.value.increment_id as string).split("-")[0]
      : "";
    const paymentMethod = productConfiguration.value.method.toString() || "";

    const priceTotal = ref(0);
    const payment = (price) => {
      priceTotal.value = price;
      if (paymentMethod == "vnpay") {
        paymentVnpay();
      }
      if (paymentMethod == "shopee_pay") {
        paymentShopeepay();
      }
    };

    const statusShopeeOrder = ref("");
    const changeStatusShopeeOrder = async () => {
      const amount = route.value.query?.amount 
        ? parseFloat(route.value.query.amount as string) / 100
        : priceTotal.value;
      const referenceId= route.value.query?.reference_id as string || incrementId;

      const result = await oderStore.changeStatusShopeeOrder(
        referenceId,
        amount.toString()
      );
      if (result && result?.status == 3) {
        statusShopeeOrder.value = "success";
      } else {
        statusShopeeOrder.value = "failed";
      }
    };

    const paymentShopeepay = async () => {
      const date = new Date();
      const { days, hours, minutes, seconds } = getTimeLeft(date);
      let body = {
        orderId: incrementId + "-" + hours + minutes + seconds,
        amount: priceTotal.value,
        platform_type: "pc",
        return_url:
          process.env.VSF_STORE_URL +
          `/odershopeepayment?increment_id=${incrementId}&method=shopeepay`,
      };
      await oderStore.createPaymentUrlShopee(body);

      if (redirectUrl.value && redirectUrl.value.code == 200) {
        const url = redirectUrl.value?.result?.redirect_url_http;
        if (url) {
          window.location.href = url;
        }
      } else {
        sendNotification({
          id: Symbol("paymentShopeePay_Error"),
          type: "info",
          message: redirectUrl.value?.message,
          icon: "error",
          persist: false,
          title: "paymentShopeePay_Errorp",
        });
      }
    };

    const getTimeLeft = (dateTime) => {
      const timestamp =
        dateTime instanceof Date
          ? Math.floor(dateTime.getTime() / 1000)
          : dateTime;

      return {
        seconds: Math.floor(timestamp % 60),
        minutes: Math.floor((timestamp / 60) % 60),
        hours: Math.floor((timestamp / (60 * 60)) % 24),
        days: Math.floor(timestamp / (60 * 60 * 24)),
      };
    };

    const isCheckoutLoading = ref(false);
    const paymentVnpay = async () => {
      const date = new Date();
      const { days, hours, minutes, seconds } = getTimeLeft(date);
      isCheckoutLoading.value = true;
      const body = {
        amount: priceTotal.value,
        orderInfo: "canifa web order",
        orderId: incrementId + "-" + hours + minutes + seconds,
        language: "vn",
      };
      await oderStore.createPaymentUrlVnpay(body);

      if (paymentUrl.value && paymentUrl.value.code == 200) {
        const url = paymentUrl.value.result.paymentUrl;
        window.location.href = url;
      } else {
        sendNotification({
          id: Symbol("paymentVnPay_Error"),
          type: "info",
          message: paymentUrl.value?.message,
          icon: "error",
          persist: false,
          title: "paymentVnPay_Error",
        });
      }
    };

    const orderTracking = () => {
      if (!isAuthenticated.value) {
        router.push({
          path: "/tra-don-hang",
          // query: {
          //   increment_id: incrementId,
          // },
        });
      } else {
        router.push("/customer/order-history/" + incrementId);
      }
    };

    const changePaymentMethod = () => {
      if (isAuthenticated.value) {
        router.push("/customer/order-history/" + incrementId);
      }
    };

    onMounted(async () => {
      await changeStatusShopeeOrder();
    });

    return {
      isCancelPayment,
      confirmCancel,
      cancelCancel,
      payment,
      orderTracking,
      changePaymentMethod,
      statusShopeeOrder,
    };
  },
});
